import { apiClient } from './api-client';

export interface EquipmentCategory {
  id: string;
  tenantId: string;
  name: string;
  description: string | null;
  isActive: boolean;
  deletedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface EquipmentCategoryListResponse {
  items: EquipmentCategory[];
  page: number;
  pageSize: number;
  total: number;
}

export interface CreateEquipmentCategoryPayload {
  name: string;
  description?: string;
}
export type UpdateEquipmentCategoryPayload = Partial<CreateEquipmentCategoryPayload> & {
  isActive?: boolean;
};

export const equipmentCategoryService = {
  list: (params: {
    page?: number;
    pageSize?: number;
    search?: string;
  }): Promise<EquipmentCategoryListResponse> =>
    apiClient
      .get<EquipmentCategoryListResponse>('/equipment-categories', { params })
      .then((r) => r.data),

  create: (payload: CreateEquipmentCategoryPayload): Promise<EquipmentCategory> =>
    apiClient.post<EquipmentCategory>('/equipment-categories', payload).then((r) => r.data),

  update: (id: string, payload: UpdateEquipmentCategoryPayload): Promise<EquipmentCategory> =>
    apiClient.patch<EquipmentCategory>(`/equipment-categories/${id}`, payload).then((r) => r.data),

  remove: (id: string): Promise<void> =>
    apiClient.delete(`/equipment-categories/${id}`).then(() => undefined),
};
